(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-conversion-report-in-period', {
            parent: 'report',
            url: '/employee-conversion-report-in-period?page&sort&search&searchType&startDate&endDate&divisionId',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.employeesConversionReportInPeriod.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/employee-conversion-report-in-period/employee-conversion-report-in-period.html',
                    controller: 'EmployeeConversionReportInPeriodController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'employeeName,asc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null,
                divisionId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        divisionId: $stateParams.divisionId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
